import React from "react";
import "./StartupProjects.css";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import SecurityIcon from '@material-ui/icons/Security';
export default function StartupProject() {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  function openProjectInNewWindow(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <div style={{
          height: '100%',
          background: 'red'
        }}>

        </div>
        <DialogTitle id="alert-dialog-title">
          <SecurityIcon fontSize="small" /> Locked down due to signing a nondisclosure agreement
        </DialogTitle>
        <DialogContent style={{ textAlign: "center" }}>
          <DialogContentText id="alert-dialog-description">
            You can contact me for further information.
</DialogContentText>
          <img src="./secret.gif" style={{ width: '100%' }} />
        </DialogContent>
      </Dialog>

      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p className="subTitle project-subtitle">{bigProjects.subtitle}</p>
          <div className="startup-projects-main">
            <div className="startup-project-text">
              {bigProjects.projects.map(project => {
                return (
                  <div className="saaya-health-div" onClick={() => project.link === 'https://ohmygame.io/' ? (setOpen(true)) : (openProjectInNewWindow(project.link))}>
                    <img alt="saadeddine louati Working" src={project.image}></img>
                  </div>
                );
              })}
            </div>
            <div className="starup-project-image"></div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
